import Box from "@mui/material/Box";
import Footer from "./Footer";

type LayoutLeftColumnProps = {
  isMobile: boolean;
};

export default function LayoutLeftColumn({ isMobile }: LayoutLeftColumnProps) {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: isMobile ? "30vh" : "75vh",
      }}
    >
      <Box
        sx={{
          backgroundImage: `url("./images/login.jpg")`,
          backgroundPosition: "bottom",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          position: "relative",
          height: isMobile ? "30vh" : "100%",
          marginTop: isMobile ? 0 : "-80px",
        }}
      />

      {!isMobile && (
        <Box sx={{ display: "flex", height: "25vh" }}>
          <Footer isMobile={isMobile} />
        </Box>
      )}
    </Box>
  );
}
